import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProviderWrapper } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { CurrencyProvider } from './contexts/CurrencyContext';
import CssBaseline from '@mui/material/CssBaseline';
import Routes from './routes';
import store from './store';

// Importar utilidades de administración
import './utils/adminUtils';

// Importamos el AuthProvider que hemos modificado
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    // Redux debe estar en lo más externo
    <Provider store={store}>
      {/* El AuthProvider debe estar antes del Router ya que no depende de él */}
      <AuthProvider>
        <LanguageProvider>
          <ThemeProviderWrapper>
            <CurrencyProvider>
              <CssBaseline />
              {/* El Router ahora está dentro de AuthProvider */}
              <BrowserRouter>
                <Routes />
              </BrowserRouter>
            </CurrencyProvider>
          </ThemeProviderWrapper>
        </LanguageProvider>
      </AuthProvider>
    </Provider>
  );
}

export default App;
